import { paymentProviderShortIcons, paymentProviderIcons } from '../helpers';
import { creatorbase } from '@round/api';
import { SVGProps } from 'react';

type Props = {
    variant: 'short' | 'default';
    paymentProvider: creatorbase.PaymentProvider;
} & SVGProps<SVGSVGElement>;

const PaymentProviderIcon = ({ paymentProvider, variant, ...props }: Props) => {
    const Icon =
        variant === 'short' ? paymentProviderShortIcons[paymentProvider] : paymentProviderIcons[paymentProvider];
    return <Icon width={16} height={16} {...props} />;
};

export default PaymentProviderIcon;
